export default __webpack_public_path__ + "static/user-orange-31b9b4f2ed9594944dbf25e30114c27b.png";